window.c24LpFrameJsReady.then(function() {
    window.Check24 = window.Check24 || {};

    window.Check24.yellowBoxInput = {

        init: function () {
            window.Check24.yellowBoxInput.yellowBox = document.querySelectorAll('.c24-yellow-box.error');
            window.Check24.yellowBoxInput.yellowForm = document.querySelectorAll('.c24-form-evo');
            window.Check24.yellowBoxInput.inputField = document.querySelectorAll('.c24-yellow-box-input');
            window.Check24.yellowBoxInput.inputFlex = document.querySelectorAll('.c24-yellow-input-flex');
            window.Check24.yellowBoxInput.selectWrapper = document.querySelectorAll('.c24-yellow-select-wrapper');
            window.Check24.yellowBoxInput.selectToggleWrapper = document.querySelectorAll('.c24-yellow-select-toggle-wrapper');
            window.Check24.yellowBoxInput.toggleTab = document.querySelectorAll('.c24-yellow-tab');
            window.Check24.yellowBoxInput.inputWrapper = document.querySelectorAll('.c24-yellow-box-input-wrapper');
            window.Check24.yellowBoxInput.closeError();
            window.Check24.yellowBoxInput.openError();
            window.Check24.yellowBoxInput.selectOption();
            window.Check24.yellowBoxInput.setDefaultOption();
            window.Check24.yellowBoxInput.toggleSelectTabs();
            window.Check24.yellowBoxInput.toggleSelectOption();
        },

        openError: function () {
            window.Check24.yellowBoxInput.yellowForm.forEach(function (element) {
                element.addEventListener('submit', function () {
                    element.querySelectorAll('.c24-yellow-box-input-wrapper').forEach(function (ele) {
                        let input = ele.querySelector('.c24-yellow-input-evo');
                        if ((input.value === '' || !input.value) && input.classList && !input.classList.contains('c24-yellow-input-noerror')) {
                            ele.closest('.c24-yellow-box').classList.add('error');
                            ele.classList.add('error');
                        }
                    });
                });
            });
        },

        closeError: function () {
            window.Check24.yellowBoxInput.inputField.forEach(function (ele) {
                ele.addEventListener('focus', function () {
                    window.Check24.removeClass('.c24-yellow-box-input-wrapper', 'error');
                    window.Check24.hide('.c24-form-error-singleline');
                });
            });
        },

        setTabActive: function (tab) {
            tab.classList.add('active');
            const img = tab.querySelector('.c24-yellow-select-img');
            const imgSrc = img.getAttribute('src');
            let colouredImgSrc = imgSrc.replace('grey', 'coloured');
            img.setAttribute('src', colouredImgSrc);
            tab.querySelector('.c24-yellow-select-input').value = 'yes';
        },

        setTabInactive: function (tab) {
            tab.classList.remove('active');
            const img = tab.querySelector('.c24-yellow-select-img');
            const greyImgSource = img.getAttribute('src').replace('coloured', 'grey');
            img.setAttribute('src', greyImgSource);
            tab.querySelector('.c24-yellow-select-input').value = 'no';
        },

        selectOption: function () {
            window.Check24.yellowBoxInput.selectWrapper.forEach(function (ele) {
                ele.addEventListener('click', function () {
                    ele.classList.toggle('active');
                    if (ele.classList.contains('active')) {
                        window.Check24.yellowBoxInput.setTabActive(ele);
                    } else {
                        window.Check24.yellowBoxInput.setTabInactive(ele);
                    }
                });
            });
        },

        toggleSelectOption: function () {
            window.Check24.yellowBoxInput.selectToggleWrapper.forEach(function (ele) {
                ele.addEventListener('click', function () {
                    window.Check24.yellowBoxInput.selectToggleWrapper.forEach(function (ele) {
                        window.Check24.yellowBoxInput.setTabInactive(ele);
                    });
                    window.Check24.yellowBoxInput.setTabActive(ele);
                });
            });
        },

        setDefaultOption: function () {
            window.Check24.yellowBoxInput.selectWrapper.forEach(function (ele) {
                if (ele.querySelector('.c24-yellow-select-input').value === 'yes' || ele.classList.contains('active')) {
                    window.Check24.yellowBoxInput.setTabActive(ele);
                }
            });
            window.Check24.yellowBoxInput.selectToggleWrapper.forEach(function (ele) {
                const hasBpm = ele.closest('.c24-select-tabs').classList.contains('bpm');
                if (ele.querySelector('.c24-yellow-select-input').value === 'yes' && !hasBpm) {
                    window.Check24.yellowBoxInput.setTabActive(ele);
                }
                if (ele.classList.contains('active') && hasBpm) {
                    window.Check24.yellowBoxInput.setTabActive(ele);
                }
            });
        },

        toggleSelectTabs: function () {
            window.Check24.yellowBoxInput.toggleTab.forEach(function (ele) {
                ele.addEventListener('click', function () {
                    window.Check24.removeClass('.c24-yellow-tab', 'active');
                    ele.classList.add('active');
                });
            });
        },
    };
});

window.c24DomReady(function() {
    window.c24LpFrameJsReady.then(function() {
        window.c24LpCssLoaded.then(function() {
            window.Check24.yellowBoxInput.init();
        });
    });
});
